export enum WorkOrderDocumentSendTypeVO
{
    PostMail = 1,
    Email = 2,
    PostMailAndEmail = 3,
    SoloSdi = 4,
    Pec = 5
}
